<template>
  <div v-if="documents">
    <b-table :data="documents">
      <b-table-column field="DocName" label="Dateiname" v-slot="props">
        <slot :docName="props.row.DocName">
          {{ props.row.DocName }}
        </slot>
      </b-table-column>

      <b-table-column field="Timestamp" label="Datum" v-slot="props">
        {{ props.row.Timestamp | prettyDate }}
      </b-table-column>

      <b-table-column
        field="InferredDocumentType"
        label="Dokumententyp"
        v-slot="props"
      >
        <TypeTag
          :docType="props.row.InferredDocumentType"
          :isError="props.row.ExtractedTextDocName == 'ERROR'"
        />
      </b-table-column>

      <template v-slot:empty>
        <div>
          <section class="hero is-medium">
            <div class="hero-body">
              <div class="container has-text-centered">
                <h1 class="title has-text-grey">
                  Keine Dokumente verfügbar
                </h1>
                <h2 class="subtitle has-text-grey">
                  <router-link
                    class="has-text-weight-bold"
                    :to="{ name: 'DocumentUpload' }"
                    >Hier</router-link
                  >
                  geht es zum Upload
                </h2>
              </div>
            </div>
          </section>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import TypeTag from "@/components/TypeTag";

export default {
  components: { TypeTag },
  props: {
    documents: { type: Array, required: false, default: () => [] }
  }
};
</script>

<style></style>
